import type { ComponentProps } from 'react';
import { AvatarBase } from '@/components/Avatar/base';
import Icon from '@/components/Icon/Icon';
type Props = {
  /** アプリの名称を指定してください。altとして利用します */
  name?: string;
} & Omit<ComponentProps<typeof AvatarBase>, 'alt' | 'fallback' | 'shape' | 'variant'>;

/**
 * アプリのアバターを表示するコンポーネントです。
 * srcが見つからない場合、アプリのアイコンがフォールバックとして表示されます。
 */
export function AvatarApp(props: Props) {
  return <AvatarBase {...props} alt={props.name ?? props.src ?? ''} fallback={<Icon iconName="AppsIcon" className="bg-none" />} className="rounded-none bg-transparent" />;
}